import React, { useContext } from 'react';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import { Box, Typography } from '@mui/material';
import ExerciseCard from './ExerciseCard';
import BodyPart from './BodyPart';
import RightArrowIcon from '../../assets/right-arrow.png'
import LeftArrowIcon from '../../assets/left-arrow.png';

const LeftArrow = () => {
  const { scrollPrev } = useContext(VisibilityContext);

  return (
    <Typography onClick={() => scrollPrev()} className="right-arrow">
      <img src={LeftArrowIcon} alt="right-arrow" />
    </Typography>
  );
};

const RightArrow = () => {
  const { scrollNext } = useContext(VisibilityContext);

  return (
    <Typography onClick={() => scrollNext()} className="left-arrow">
      <img src={RightArrowIcon} alt="right-arrow" />
    </Typography>
  );
};

const HorizontalScrollbar = ({ data, bodyPart, setBodyPart }) => (
//   <div className='flex'>

  
  
//     {data && Array.isArray(data) && data.map((item) => (
//       <Box
//         key={item.id || item}
//         itemId={item.id || item}
//         title={item.id || item}
//         m="0 40px"
        
//       >
//          <BodyPart item={item} setBodyPart={setBodyPart} bodyPart={bodyPart} /> 
//           <ExerciseCard exercise={item} /> 
//       </Box>
//     ))}
  
//   </div>
<div className='flex' style={{ overflowX: 'auto', display: 'flex' }}>
  {data && Array.isArray(data) && data.map((item) => (
    <Box
      key={item.id || item}
      itemId={item.id || item}
      title={item.id || item}
      m="0 40px"
    >
      <BodyPart item={item} setBodyPart={setBodyPart} bodyPart={bodyPart} /> 
      <ExerciseCard exercise={item} /> 
    </Box>
  ))}
</div>

);

export default HorizontalScrollbar;